import React from 'react';
import { Create, SimpleForm, TextInput, required } from 'react-admin';
import { CreateToolbar } from '../../../components/Toolbar/CreateToolbar';

export const DomainsCreate = (props) => {
	return (
		<>
			<Create {...props} title='Create Domain'>
				<SimpleForm variant='standard' margin='normal' toolbar={<CreateToolbar />}>
						<TextInput source='name' validate={required()} fullWidth />
						<TextInput source='description' label='Description' multiline fullWidth />
				</SimpleForm>
			</Create>
		</>
	);
}